module.exports = __webpack_public_path__ + "assets/login-frontend/XING-Sans-Bold-8f689aa34bc0d5aa.woff";